<template>
  <v-card>
    <v-layout row justify-space-between pl-4 pb-3 style="max-height: 64px">
      <h2 class="pt-2 mt-1">{{$lang.labels.allergens}}</h2>
      <v-btn
          flat
          dark
          color="secondary"
          icon
          @click.stop="$emit('close')">X
      </v-btn>
    </v-layout>
    <v-layout wrap row pl-4 align-start fill-height>
      <template v-for="(item, index) in allergens">
        <v-flex xs12 pb-1 :key="index">
          <span class="p-0 m-0">- {{formatAllergen(item)}}</span>
        </v-flex>
      </template>
    </v-layout>
    <v-layout row justify-end pb-1 pt-3>
      <v-btn
          small
          color="primary"
          @click.stop="$emit('close')">OK
      </v-btn>
    </v-layout>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    props: ['catalogAllergens', 'allergens'],
    data() {
      return {
        err: '',
        warning: '',
      };
    },
    computed: mapGetters({
      company: 'company',
    }),
    watch: {},
    methods: {
      formatAllergen(id) {
        // eslint-disable-next-line max-len
        return this.catalogAllergens.filter(x => x.allergenId === id)[0].name[this.$route.lang] || this.catalogAllergens.filter(x => x.allergenId === id)[0].name[this.company.defaultLanguage];
      },
    },
    created() {
    },
  };

</script>



// WEBPACK FOOTER //
// src/components/webshop/modals/Allergens.vue